export default __webpack_public_path__ + "static/media/R5C_8074.aaf38281.jpg";